/* eslint-disable */
import {
  faEye,
  faStar,
  faUser,
  faLock,
  faMagic,
  faChild,
  faTrophy,
  faDesktop,
  faBullseye,
  faSuitcase
} from '@fortawesome/free-solid-svg-icons'

export default [
  {
    icon: faDesktop,
    title: 'Tenés Seguro',
    description: 'Yey'
  }
]
